<template>
  <VMask v-model="show">
    <div class="d-box noselect" @click.stop>
      <div class="title">
        <span>认证会员</span>
        <div class="icon-box" @click.stop="close">
          <i class="icon"></i>
        </div>
      </div>
      <div class="content">
        <input type="text" v-model="formData.memberCode" class="input-txt" placeholder="请输入会员兑换码" />
        <div class="tip">* 会员用户将畅享使用平台所有内容</div>
        <div class="btns">
          <button class="btn btn-cancel" @click.stop="close">取消</button>
          <button class="btn btn-ok" @click.stop="submit">确定</button>
        </div>
      </div>
    </div>
  </VMask>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import util from 'libs/util';
import VMask from 'base/mask'
export default {
  computed: {
    ...mapGetters([
      'getUserInfo'
    ]),
  },
  components: {
    VMask: VMask
  },
  data() {
    return {
      show: false,
      formData: {
        code: ''
      }
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    open(id) {
      this.$user.checkIsLogin(() => {
        this.show = true;
      });
    },
    async submit() {
      const formData = this.formData;
      const config = [{
        id: 'memberCode',
        rule: {
          required: {
            message: '请输入会员兑换码'
          }
        }
      }];
      let { result, params } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      this.$loading.show();
      const res = await this.$post('/user/userc/becomemember.json', {
        memberCode: formData.memberCode
      });
      this.$loading.hide();
      if (res.status == 200) {
        const data = res.data;
        this.show = false;
        await this.$store.dispatch('queryUserInfo');
        let endDate;
        if (this.getUserInfo.memberEndDateOutput) {
          endDate = util.date.format(this.getUserInfo.memberEndDateOutput, 'yyyy年MM月dd日')
        }
        this.$toast(`恭喜您已成功开通会员，会员有效期至${endDate}`, {
          timeout: 5000
        })
        this.$eventBus.$emit('buyCallback');
      } else {
        this.$toast(res.message);
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.d-box {
  .content {
    padding: 30px 40px;
    background: #fff;
    .input-txt {
      width: 360px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: solid 1px #DDDDDD;
      padding: 0 12px;
      box-sizing: border-box;
    }
    .tip {
      color: #999;
      margin-top: 8px;
    }
  }
}
</style>